import { object } from '@art-suite/art-core-ts';
import { apiDate, boolean, string, uuid, zenum, zodLess, ZodLessInfer } from '@kaiizen/zod-less';
import { ApiOrgSchema } from './ApiOrgSchema';
import { ApiUserSchema } from './ApiUserSchema';

// *******************************************************************
// Access Control Enums
// *******************************************************************
export const ApiUserOrgRoleSchema = zodLess('admin|manager|fieldUser|opsUser|viewer');
export type ApiUserOrgRole = ZodLessInfer<typeof ApiUserOrgRoleSchema>;
export const ApiUserOrgRoles: readonly ApiUserOrgRole[] = ApiUserOrgRoleSchema.options;
export const ApiUserOrgRolesByName = object(ApiUserOrgRoles) as Record<ApiUserOrgRole, ApiUserOrgRole>;

export const ApiSubjectSchema = zenum(
  'Org',
  'OrgContractor',
  'OrgMarket',
  'OrgProduct',
  'OrgProperty',
  'OrgSettings',
  'PropertyProject',
  'PropertyProjectReactivation',
  'ScanTemplate',
  'Scan',
  'UserToOrg',
  'all',
);
export type ApiSubject = ZodLessInfer<typeof ApiSubjectSchema>;
export const ApiSubjects = ApiSubjectSchema.options;
export const ApiSubjectsByName = object(ApiSubjects) as Record<ApiSubject, ApiSubject>;

export const ApiActionSchema = zodLess('create|read|update|delete|approve|manage');
export type ApiAction = ZodLessInfer<typeof ApiActionSchema>;
export const ApiActions = ApiActionSchema.options;
export const ApiActionsByName = object(ApiActions) as Record<ApiAction, ApiAction>;

// *******************************************************************
// UserOrg API
// *******************************************************************
export const ApiUserPermissionSchema = zodLess({
  subject: ApiSubjectSchema,
  actions: [ApiActionSchema],
});
export type ApiUserPermission = ZodLessInfer<typeof ApiUserPermissionSchema>;

export const ApiUserPermissionsSchema = zodLess({
  orgId: uuid,
  orgName: string,
  role: ApiUserOrgRoleSchema,
  permissions: [ApiUserPermissionSchema],
  isSuperAdmin: boolean,
});
export type ApiUserPermissions = ZodLessInfer<typeof ApiUserPermissionsSchema>;

export const ApiUserOrgSchema = zodLess({
  userId: uuid,
  orgId: uuid,
  role: ApiUserOrgRoleSchema,
  createdAt: apiDate,
  updatedAt: apiDate,
});
export type ApiUserOrg = ZodLessInfer<typeof ApiUserOrgSchema>;

export const ApiUserWithRoleSchema = ApiUserSchema.extend({
  role: ApiUserOrgRoleSchema,
});
export type ApiUserWithRole = ZodLessInfer<typeof ApiUserWithRoleSchema>;

export const ApiOrgWithRoleSchema = ApiOrgSchema.extend({
  role: ApiUserOrgRoleSchema,
});
export type ApiOrgWithRole = ZodLessInfer<typeof ApiOrgWithRoleSchema>;
